<!--公司介绍-->
<template>
  <div class="solution2">
    <!--顶部介绍-->
    <div class="x-top">
      <guide :guide="guide"></guide>
      <div class="x-top-container">
        <p class="title x-top-container-title" style="margin-bottom: 2rem"></p>
        <div class="x-top-container-des">
          珠海格力建筑环境与节能研究院隶属于珠海格力电器股份有限公司，致力于智慧建筑行业解决方案及相关产品的开发。
        </div>
      </div>
    </div>
    <!--主体内容-->
    <div class="x-container">
      <!--背景介绍-->
      <section class="x-section">
        <p class="x-title">荣誉资质</p>
        <div class="des">
          目前已针对智慧建筑、智慧暖通的核心硬件、软件产品申请发明专利超200项，软件著作权6项。
        </div>
      </section>
      <section>
        <!--轮播图-->
        <div class="carousel">
          <!--中间图片-->
          <div ref="swiper-container" class="swiper-container swiper-container_companyProfile">
            <div ref="swiper-wrapper" class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in carousels" :key="'carousel'+index">
                <picture>
                  <source media="(min-width: 768px)" :srcset="item.imgSrc">
                  <source media="(min-width: 320px)" :srcset="item.imgSrcMobile">
                  <img :src="item.imgSrc">
                </picture>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import guide from '@/components/guide'

  export default {
    name: "solution1",
    components: {
      guide,
    },
    data() {
      return {
        guide: [
          // {label: '格力智能楼宇'},
          {label: '关于我们'},
          {label: '介绍'},
        ],
        // 轮播图
        mySwiper: null,
        carousels: [
          {
            imgSrc: require("@/assets/img/pc/about/about1/pic1.png"),
            imgSrcMobile: require("@/assets/img/mobile/about/about1/pic1.png"),
          },
          {
            imgSrc: require("@/assets/img/pc/about/about1/pic2.png"),
            imgSrcMobile: require("@/assets/img/mobile/about/about1/pic2.png"),
          },
        ]
      }
    },
    methods: {
      // 初始化工程案例轮播图
      initSwiperProjects() {
        this.mySwiper = new this.$Swiper('.swiper-container_companyProfile', {
          // autoplay: true,
          autoplay: {
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination'
          },
          spaceBetween: 6,
          delay: 1000,
          loop: true,
          slidesPerView: 1,
          slidesPerGroup: 1,
          speed: 1000,
          grabCursor: true,
          breakpoints: {
            320: {
              // autoplay: true,
              // loop: true,
              slidesPerView: 1,
              slidesPerGroup: 1,
            }
          }
        })
      },
    },
    mounted() {
      this.initSwiperProjects();
    }
  }
</script>

<style scoped lang="less">
  .x-top {
    min-height: 23rem;
    .x-top-img {
      text-align: right;
      img {
        width: 20rem;
      }
    }
  }
  /*轮播图*/
  .carousel{
    .swiper-container{
      padding-bottom: 2rem;
    }
  }
</style>
<style lang="less" scoped>
  @media only screen and (min-width: 320px) {
    .x-top {
      background: url("../../../assets/img/mobile/about/about1/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }
  }

  @media only screen and (min-width: 768px) {
    .x-top {
      background: url("../../../assets/img/pc/about/about1/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }
  }
</style>
